import Layout from "../Layout";
import Footer from "../../components/Footer";
import RegisterContainer from "../../containers/RegisterContainer";
import GeneralHeader from "../../components/GeneralHeader";

const RegisterPage = () => {
  return (
    <Layout
      header={<GeneralHeader />}
      center={<RegisterContainer />}
      footer={<Footer />}
    />
  );
}

export default RegisterPage;